import React, {useState, useEffect, useContext} from 'react';
import {loadModules} from 'esri-loader';
import Button, { ButtonGroup } from 'calcite-react/Button';
import Form, { FormControl, FormControlLabel } from 'calcite-react/Form'; 
import Select from 'calcite-react/Select';
import Switch from 'calcite-react/Switch';
import Menu, { MenuTitle, MenuItem } from 'calcite-react/Menu';
import { CalciteH5 } from 'calcite-react/Elements';
import QuestionIcon from 'calcite-ui-icons-react/QuestionIcon';
import LayersIcon from 'calcite-ui-icons-react/LayersIcon';
import LegendIcon from 'calcite-ui-icons-react/LegendIcon';
import BookmarkIcon from 'calcite-ui-icons-react/BookmarkIcon';
import MeasureIcon from 'calcite-ui-icons-react/MeasureIcon';
import PlusIcon from 'calcite-ui-icons-react/PlusIcon';
import PopupIcon from 'calcite-ui-icons-react/PopupIcon';
import PanDragIcon from 'calcite-ui-icons-react/PanDragIcon';
import CursorSelectionIcon from 'calcite-ui-icons-react/CursorSelectionIcon';
import TrashIcon from 'calcite-ui-icons-react/TrashIcon';
import List, {
    ListItem,
    ListHeader,
    ListItemTitle,
    ListItemSubtitle
} from 'calcite-react/List';

import Mapstore from '../MapStore';
import InformationIcon from 'calcite-ui-icons-react/InformationIcon';

const Information = ({view}) => {
    const nodeRef = React.createRef(); //
    const [selected, setSelected] = useState({layerName: null, layer: null, fieldName: null, fieldValue: null, uniqueFieldValues: [], expression: null, check: false});
    const store = useContext(Mapstore);

    let measurement;

    const expressionLookup = {
        'is': '=',
        'is not': '<>',
        'is blank': 'IS NULL',
        'is not blank': 'IS NOT NULL'
    }

    const selectLayerHandler = ((value, item) => {
        console.log("layer");
        const foundLayer = view.map.layers.find(function(layer) {
            return layer.title === value;
        });
        setSelected({...selected, layerName: value, layer: foundLayer}); 
    });

    const selectExpressionHandler = ((value, item) => {
        console.log("expression");
        setSelected({...selected, expression: value}); 
    });
    
    useEffect(() => {
        const runEffect = async () => {
            loadModules(['esri/layers/FeatureLayer'], {css: true}).then(([FeatureLayer]) => {
                if (view.layerViews.length > 0){
                    view.layerViews.forEach((layerView) => {
                        //console.log(layerView.layer.title);

                    });
                }
            }).catch((err) => console.error(err));  
        }
        runEffect();
        return () => {
            if (!!store.measurement) {
                console.log('closed');
                store.measurement.container = null;
            }
        }
    }, [nodeRef.current]);

    return (
        <React.Fragment>
            <div id='information' style={{padding: 10, lineHeight: 1}} ref={nodeRef}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <CalciteH5 style={{textAlign: 'center', marginBottom: 0, fontWeight: 'bold'}}>GETTING STARTED</CalciteH5><QuestionIcon style={{marginRight: '0.25rem'}} size={'1.25rem'} filled/>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <div style={{fontSize: '10pt', fontStyle: 'italic'}}>Click the left buttons to toggle the selected sliding panel content or again to hide the panel.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <div style={{fontSize: '12pt', fontWeight: 'bold'}}>Action Bar Functionality</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <LayersIcon style={{marginRight: '5px'}} size={16} filled/><div style={{fontSize: '10pt'}}>Allows you to turn layers on and off.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <LegendIcon style={{paddingRight: '5px'}} size={20} filled/><div style={{fontSize: '10pt'}}>Key or legend for point, line, or polygon symbols from map layers.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <BookmarkIcon style={{paddingRight: '5px'}} size={20} filled/><div style={{fontSize: '10pt'}}>Zoom to a preset area or extent.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <MeasureIcon style={{paddingRight: '5px'}} size={20} filled/><div style={{fontSize: '10pt'}}>Select tools to Measure distance or area by drawing on the map.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <InformationIcon style={{paddingRight: '5px'}} size={24} filled/><div style={{fontSize: '10pt'}}>Currently selected and visible. Side panel content includes Instructions or other information.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <div style={{fontSize: '12pt', fontWeight: 'bold'}}>Map Interaction</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <PanDragIcon style={{paddingRight: '5px'}} size={24}/><div style={{fontSize: '10pt', fontStyle: 'italic'}}>Click and drag to pan the map area.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <PlusIcon style={{paddingRight: '5px'}} size={40}/><div style={{fontSize: '10pt', fontStyle: 'italic'}}>Use the + and &minus; buttons to zoom in and out or scroll with middle 
                    mouse wheel. Note: You can also double click to zoom in.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
                <div style={{display: 'flex'}}>
                    <CursorSelectionIcon style={{paddingRight: '5px'}} size={30}/><div style={{fontSize: '10pt', fontStyle: 'italic'}}>Single click on a feature in the map to see additional information.</div>
                </div>
                <hr style={{opacity: 0.5}}/>
            </div>
        </React.Fragment>
    )  
}

export { Information };